module.exports = __webpack_public_path__ + "media/header_nove_bloky.a1f3b0a7.mp4";